module.exports = __webpack_public_path__ + "media/components/src/assets/images/tables/block_table_8-58a1625c2d1bfe44eaec94de0a227e76.jpg";